import { Button, Col, Result, Row, Space, Spin, Typography } from "antd";
import { FunctionComponent, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useStateIfMounted } from "use-state-if-mounted";
import {
  ROUTE_DASHBOARD_TAGS,
  ROUTE_DASHBOARD_TAG_EDIT,
} from "../../../shared/app-constants";
import DeleteBtn from "../../../shared/delete-btn";
import getDashboardRoute from "../../../shared/get-dashboard-route";
import GuardedElement from "../../../shared/guarded-element";
import Permissions from "../../../shared/permissions";
import TagModel from "../../../shared/tag-model";
import uDayjs from "../../../shared/uDayjs";
import httpClient from "../../http-client";

interface TagDetailPageProps {
  self?: boolean;
}

const TagDetailPage: FunctionComponent<TagDetailPageProps> = () => {
  const { id } = useParams();
  const [loading, setLoading] = useStateIfMounted(true);
  const [data, setData] = useStateIfMounted<TagModel | undefined>(undefined);

  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      setLoading(true);
      setData(undefined);
      try {
        const response = await httpClient.get(`gear/tags/${id}`);
        if (response.data?.data) {
          setData(response.data.data);
        }
      } catch (e) {}
      setLoading(false);
    })();
  }, [id]);

  return (
    <div>
      <Row>
        <Col xs={24}>
          {!loading && !data && (
            <Result
              status={404}
              title="Not found!"
              subTitle="The tag you looking for can't be found!"
              extra={
                <Link
                  to={{ pathname: getDashboardRoute({}, ROUTE_DASHBOARD_TAGS) }}
                >
                  <Button type="link">Go Back</Button>
                </Link>
              }
            />
          )}
          {loading && <Spin />}
          {!loading && data && (
            <table className="gear-table">
              <tbody>
                <tr>
                  <th>Name</th>
                  <td>{data.name}</td>
                </tr>

                <tr>
                  <th>Created By</th>
                  <td>
                    <div>
                      <Typography.Text>
                        {(data as any)?.created_by?.name}
                      </Typography.Text>{" "}
                    </div>
                    <Typography.Text type="secondary">
                      {uDayjs(data.created_at).format(`DD/MM/YYYY hh:mma`)}
                    </Typography.Text>
                  </td>
                </tr>
                <tr>
                  <th>Updated By</th>
                  <td>
                    <div>
                      <Typography.Text>
                        {(data as any)?.updated_by?.name}
                      </Typography.Text>{" "}
                    </div>
                    <Typography.Text type="secondary">
                      {uDayjs(data.updated_at).format(`DD/MM/YYYY hh:mma`)}
                    </Typography.Text>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <Space>
                      <GuardedElement permissions={[Permissions.EDIT_GEAR]}>
                        <Button type="default" size="small">
                          <Link
                            to={{
                              pathname: getDashboardRoute(
                                { id } as any,
                                ROUTE_DASHBOARD_TAG_EDIT
                              ),
                            }}
                          >
                            Edit
                          </Link>
                        </Button>
                      </GuardedElement>
                      <GuardedElement permissions={[Permissions.DELETE_GEAR]}>
                        <DeleteBtn
                          path={`gear/tags/${data.id}`}
                          httpClient={httpClient}
                          onDone={() => {
                            navigate({
                              pathname: getDashboardRoute(
                                { id } as any,
                                ROUTE_DASHBOARD_TAGS
                              ),
                            });
                          }}
                        />
                      </GuardedElement>
                    </Space>
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TagDetailPage;
